import React, { useState, useEffect } from "react";
import axios from "../../api/axios";
import "./LoginSignup.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

export default function LoginSignup() {
  const navigate = useNavigate();

  const [isActive, setIsActive] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showLoginPassword, setShowLoginPassword] = useState(false);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [showSignupOtp, setShowSignupOtp] = useState(false);
  const [signupOtpData, setSignupOtpData] = useState({
  email: "",
  otp: "",
});
  const [signupData, setSignupData] = useState({
  name: "",
  email: "",
  phone: "",
  companyName: "",
  compCode: "",
  password: "",
  role: "user",
});
  const [loginData, setLoginData] = useState({
    phone: "",
    password: "",
  });

  const [forgotEmail, setForgotEmail] = useState("");

  const [otpData, setOtpData] = useState({
    email: "",
    otp: "",
    newPassword: "",
  });

  const [showForgot, setShowForgot] = useState(false);

  // ================= VALIDATION =================

  const validateSignup = () => {
    if (!signupData.name.trim()) return toast.error("Name required");

    if (!signupData.email.trim()) return toast.error("Email required");

    const phoneRegex = /^[6-9]\d{9}$/;
    if (!phoneRegex.test(signupData.phone))
      return toast.error("Enter valid 10 digit mobile number");

    if (!signupData.companyName)
      return toast.error("Please select company");

    const passwordRegex = /^\d{4}$/;
    if (!passwordRegex.test(signupData.password))
      return toast.error("Password must be exactly 4 digits");

    return true;
  };

  const validateLogin = () => {
    const phoneRegex = /^[6-9]\d{9}$/;

    if (!phoneRegex.test(loginData.phone))
      return toast.error("Enter valid mobile number");

    if (!loginData.password)
      return toast.error("Password required");

    return true;
  };

  // ================= FETCH COMPANIES =================

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const res = await axios.get("/company/public");
        setCompanyOptions(res.data);
      } catch (err) {
        toast.error("Failed to load companies");
      }
    };

    fetchCompanies();
  }, []);


  
  // ================= REGISTER =================

const handleSendSignupOtp = async (e) => {
  e.preventDefault();

  if (!validateSignup()) return;

  try {
    await axios.post("/auth/send-signup-otp", {
      email: signupData.email,
    });

    toast.success("OTP sent to email");

    setSignupOtpData({
      email: signupData.email,
      otp: "",
    });

    setShowSignupOtp(true);

  } catch (err) {
    const msg = err.response?.data?.message || "";

    if (msg.includes("already")) {
      toast.error("Email already registered. Please login.");
    } else {
      toast.error(msg || "Failed to send OTP");
    }
  }
};


const handleVerifySignupOtp = async () => {
  if (!signupOtpData.otp)
    return toast.error("Enter OTP");

  try {
    await axios.post("/auth/verify-signup-otp", signupOtpData);

    await axios.post("/auth/register", signupData);

    toast.success("Registration successful");

    setSignupData({
      name: "",
      email: "",
      phone: "",
      companyName: "",
      compCode: "",
      password: "",
      role: "user",
    });

    setShowSignupOtp(false);
    setIsActive(false);

  } catch (err) {
    const msg = err.response?.data?.message || "";

    // ✅ HANDLE DUPLICATE EMAIL
    if (msg.includes("already")) {
      toast.error("Email already registered. Please login.");
    } else if (msg.includes("phone")) {
      toast.error("Mobile number already exists");
    } else {
      toast.error(msg || "Invalid OTP");
    }
  }
};
  // ================= LOGIN =================

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!validateLogin()) return;

    try {
      const res = await axios.post("/auth/login", loginData);

      const { token, user } = res.data;

      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("role", user.role);

      toast.success("Login Successful");

      if (user.role === "admin") {
        navigate("/admin-dashboard");
      } else {
        navigate("/user-dashboard");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Login failed");
    }
  };

  // ================= FORGOT PASSWORD =================

  const handleForgot = async () => {
    if (!forgotEmail) return toast.error("Enter email");

    try {
      await axios.post("/auth/forgot-password", { email: forgotEmail });

      toast.success("OTP sent to email");

      setOtpData({ ...otpData, email: forgotEmail });
    } catch (err) {
      toast.error(err.response?.data?.message || "Error sending OTP");
    }
  };

  // ================= RESET PASSWORD =================

  const handleResetPassword = async () => {
    if (!otpData.otp || !otpData.newPassword)
      return toast.error("Enter OTP and new password");

    try {
      await axios.post("/auth/reset-password", otpData);

      toast.success("Password reset successful");

      setShowForgot(false);

      setOtpData({
        email: "",
        otp: "",
        newPassword: "",
      });

      setForgotEmail("");
    } catch (err) {
      toast.error(err.response?.data?.message || "Invalid OTP");
    }
  };

  return (
    <div className="main-container">
      <ToastContainer position="top-right" autoClose={3000} />

      <div className={`container-box ${isActive ? "active" : ""}`}>

        {/* ================= SIGNUP ================= */}

    
          <div className="form-container sign-up">
  {!showSignupOtp ? (
    <form onSubmit={handleSendSignupOtp}>
      <h2>Create Account</h2>

      <div className="input-box">
        <input
          type="text"
          placeholder="Name"
          value={signupData.name}
          onChange={(e) =>
            setSignupData({ ...signupData, name: e.target.value })
          }
        />
      </div>

      <div className="input-box">
        <input
          type="email"
          placeholder="Email"
          value={signupData.email}
          onChange={(e) =>
            setSignupData({ ...signupData, email: e.target.value })
          }
        />
      </div>

      <div className="input-box">
        <input
          type="text"
          placeholder="Mobile Number"
          maxLength="10"
          value={signupData.phone}
          onChange={(e) =>
            setSignupData({
              ...signupData,
              phone: e.target.value.replace(/\D/g, ""),
            })
          }
        />
      </div>

      <div className="input-box">
        <select
          className="company-select"
          value={signupData.companyName || ""}
          onChange={(e) => {
            const company = JSON.parse(e.target.value);

            setSignupData({
              ...signupData,
              companyName: company.companyName,
              compCode: company.companyCode,
              hierarchicalLevel: company.hierarchicalLevel,
              relationType: company.relationType,
            });
          }}
        >
          <option value="" disabled hidden>
            Select Your Company
          </option>

          {companyOptions.map((company) => (
            <option key={company._id} value={JSON.stringify(company)}>
              {company.companyName}
            </option>
          ))}
        </select>
      </div>

      <div className="input-box password-box">
        <input
          type={showPassword ? "text" : "password"}
          placeholder="4 Digit Password"
          maxLength="4"
          value={signupData.password}
          onChange={(e) =>
            setSignupData({
              ...signupData,
              password: e.target.value.replace(/\D/g, ""),
            })
          }
        />

        <span onClick={() => setShowPassword(!showPassword)}>
          {showPassword ? "Hide" : "Show"}
        </span>
      </div>

      <button type="submit">Send OTP</button>
      <p
  style={{ cursor: "pointer", color: "blue", marginTop: "10px" }}
  onClick={() => setIsActive(false)}
>
  Already have an account? Sign In
</p>
    </form>
  ) : (
  <div className="forgot-box mt-5 ">
  <h3>Verify Email OTP</h3>

  {/* ✅ Show email instead of asking again */}
  <p className="otp-info">
    OTP sent to <b>{signupOtpData.email}</b>
  </p>

  <div className="input-box">
    <input
      type="text"
      placeholder="Enter 6 digit OTP"
      maxLength="6"
      value={signupOtpData.otp}
      onChange={(e) =>
        setSignupOtpData({
          ...signupOtpData,
          otp: e.target.value.replace(/\D/g, ""),
        })
      }
    />
  </div>

  <button onClick={handleVerifySignupOtp}>
    Verify & Register
  </button>

  <p className="back-btn" onClick={() => setShowSignupOtp(false)}>
    ← Back
  </p>
</div>
  )}
</div>
      

        {/* ================= LOGIN ================= */}

<div className={`form-container sign-in ${showSignupOtp ? "hide" : ""}`}>
          {!showForgot ? (
            <form onSubmit={handleLogin}>
              <h2>Sign In</h2>

              <div className="input-box">
                <input
                  type="text"
                  placeholder="Mobile Number"
                  maxLength="10"
                  value={loginData.phone}
                  onChange={(e) =>
                    setLoginData({
                      ...loginData,
                      phone: e.target.value.replace(/\D/g, ""),
                    })
                  }
                />
              </div>

              <div className="input-box password-box">
                <input
                  type={showLoginPassword ? "text" : "password"}
                  placeholder="Password"
                  value={loginData.password}
                  onChange={(e) =>
                    setLoginData({ ...loginData, password: e.target.value })
                  }
                />

                <span
                  onClick={() => setShowLoginPassword(!showLoginPassword)}
                >
                  {showLoginPassword ? "Hide" : "Show"}
                </span>
              </div>

              <p
                style={{ cursor: "pointer", color: "blue" }}
                onClick={() => setShowForgot(true)}
              >
                Forgot Password?
              </p>

              <button type="submit">Sign In</button>
              <p
  style={{ cursor: "pointer", color: "blue", marginTop: "10px" }}
  onClick={() => setIsActive(true)}
>
  Don't have an account? Sign Up
</p>
            </form>
          ) : (
            <div className="forgot-box">
              <h3>Reset Password</h3>

              <div className="input-box">
                <input
                  type="email"
                  placeholder="Enter Email"
                  value={forgotEmail}
                  onChange={(e) => setForgotEmail(e.target.value)}
                />
              </div>

              <button onClick={handleForgot}>Send OTP</button>

              <div className="input-box">
                <input
                  type="text"
                  placeholder="Enter OTP"
                  value={otpData.otp}
                  onChange={(e) =>
                    setOtpData({ ...otpData, otp: e.target.value })
                  }
                />
              </div>

              <div className="input-box">
                <input
                  type="password"
                  placeholder="New Password"
                  value={otpData.newPassword}
                  onChange={(e) =>
                    setOtpData({
                      ...otpData,
                      newPassword: e.target.value,
                    })
                  }
                />
              </div>

              <button onClick={handleResetPassword}>Reset Password</button>

              <p onClick={() => setShowForgot(false)}>Back to Login</p>
            </div>
          )}
        </div>

        {/* ================= OVERLAY ================= */}

        <div className="overlay-container">
          <div className="overlay">
            <div className="overlay-panel overlay-left">
              <h2>Welcome Back!</h2>
              <button className="ghost" onClick={() => setIsActive(false)}>
                Sign In
              </button>
            </div>

            <div className="overlay-panel overlay-right">
              <h2>Hello Friend!</h2>
              <button className="ghost" onClick={() => setIsActive(true)}>
                Sign Up
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}